var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sip-inbox" },
    [
      _c(
        "button",
        {
          staticClass: "sip-icon-btn sip-inbox-btn sip-header-btn--bell",
          class: { "is-open": _vm.open },
          attrs: {
            type: "button",
            title: _vm.trans("communication.notifications"),
            "aria-label": _vm.trans("communication.notifications"),
            "aria-expanded": _vm.open ? "true" : "false",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggle.apply(null, arguments)
            },
          },
        },
        [
          _c("admin-icon", { attrs: { name: "bell", size: 18 } }),
          _vm._v(" "),
          _vm.unreadCount > 0
            ? _c("span", { staticClass: "sip-inbox-badge" }, [
                _vm._v(_vm._s(_vm.badgeLabel)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "side-drawer",
        {
          attrs: {
            open: _vm.open,
            size: "sm",
            "overlay-class": "sip-inbox-drawer-overlay",
            "drawer-class": "sip-inbox-drawer",
            title: _vm.trans("communication.notifications"),
            "close-label": "Close",
            "append-to-body": true,
          },
          on: { close: _vm.close },
          scopedSlots: _vm._u(
            [
              {
                key: "title",
                fn: function () {
                  return [
                    _c(
                      "span",
                      { staticClass: "sip-inbox-title" },
                      [
                        _c("admin-icon", { attrs: { name: "bell", size: 18 } }),
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.trans("communication.notifications")) +
                            "\n            "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.unreadCount > 0
                      ? _c("span", { staticClass: "sip-inbox-count" }, [
                          _vm._v(_vm._s(_vm.unreadCount)),
                        ])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              _vm.unreadCount > 0
                ? {
                    key: "actions",
                    fn: function () {
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm sip-inbox-mark-all",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.markAllRead.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.trans("communication.mark_all_read"))
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                : null,
              {
                key: "footer",
                fn: function () {
                  return [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "btn btn-primary btn-sm sip-inbox-view-all",
                        attrs: { to: "/communication/notification" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.close.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.trans("communication.view_all_notifications")
                          )
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _vm.loading && !_vm.items.length
            ? _c("div", { staticClass: "sip-inbox-loading" }, [
                _c("span", { staticClass: "sip-skel sip-skel--lg" }),
                _vm._v(" "),
                _c("span", { staticClass: "sip-skel" }),
                _vm._v(" "),
                _c("span", { staticClass: "sip-skel sip-skel--wide" }),
              ])
            : !_vm.items.length
            ? _c("empty-state", {
                attrs: {
                  title: _vm.trans("communication.inbox_empty"),
                  description: _vm.trans("communication.inbox_empty_hint"),
                  icon: "bell",
                  size: "sm",
                },
              })
            : _c(
                "ul",
                { staticClass: "sip-inbox-list", attrs: { role: "list" } },
                _vm._l(_vm.items, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.id,
                      class: [
                        "sip-inbox-item",
                        {
                          "is-unread": item.unread,
                          "is-open": _vm.expandedId === item.id,
                        },
                      ],
                      attrs: { role: "button", tabindex: "0" },
                      on: {
                        click: function ($event) {
                          return _vm.openItem(item)
                        },
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.preventDefault()
                          return _vm.openItem(item)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "sip-inbox-item__icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c("admin-icon", {
                            attrs: { name: item.icon || "bell", size: 16 },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "sip-inbox-item__body" }, [
                        _c("span", { staticClass: "sip-inbox-item__title" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                        _vm._v(" "),
                        item.body
                          ? _c(
                              "span",
                              { staticClass: "sip-inbox-item__text" },
                              [_vm._v(_vm._s(item.body))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "sip-inbox-item__time" }, [
                          _vm._v(_vm._s(_vm.timeAgo(item.created_at))),
                        ]),
                      ]),
                      _vm._v(" "),
                      item.unread
                        ? _c("span", {
                            staticClass: "sip-inbox-item__dot",
                            attrs: { "aria-hidden": "true" },
                          })
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }